export const canUseBrowserNotifications = () =>
  typeof window !== 'undefined' && 'Notification' in window;

let brandMarkUrl = typeof window !== 'undefined'
  ? `${window.location.origin}/rmc-mark.png`
  : '/rmc-mark.png';

export const setBrowserNotificationIcon = (url) => {
  if (!url) {
    brandMarkUrl = typeof window !== 'undefined'
      ? `${window.location.origin}/rmc-mark.png`
      : '/rmc-mark.png';
    return;
  }

  if (/^https?:\/\//i.test(url)) {
    brandMarkUrl = url;
    return;
  }

  if (typeof window !== 'undefined') {
    brandMarkUrl = url.startsWith('/')
      ? `${window.location.origin}${url}`
      : url;
  } else {
    brandMarkUrl = url;
  }
};

const getBrandIconUrl = () => brandMarkUrl;

export const requestBrowserNotificationPermission = async () => {
  if (!canUseBrowserNotifications()) return 'unsupported';
  if (!window.isSecureContext) return 'insecure';
  if (Notification.permission !== 'default') return Notification.permission;

  try {
    return await Notification.requestPermission();
  } catch (error) {
    return 'denied';
  }
};

export const showBrowserNotification = async ({ title, message, refNo }) => {
  if (!canUseBrowserNotifications()) return 'unsupported';
  if (!window.isSecureContext) return 'insecure';

  let permission = Notification.permission;
  if (permission === 'default') {
    permission = await requestBrowserNotificationPermission();
  }

  if (permission !== 'granted') return permission;

  const iconUrl = getBrandIconUrl();
  const notification = new Notification(title || 'Incident notification', {
    body: [message, refNo].filter(Boolean).join('\n'),
    icon: iconUrl,
    badge: iconUrl,
    tag: refNo || title || 'incident-notification',
  });

  notification.onclick = () => {
    window.focus();
    notification.close();
  };

  return 'shown';
};
